<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md8>
        <v-alert :value="true" dense outlined type="error" v-if="error">
          {{ error }}
        </v-alert>
        <v-alert :value="true" dense outlined type="success" v-if="message">
          {{ message }}
        </v-alert>
        <v-form>
          <v-container py-0>
            <v-layout wrap>
              <v-flex xs12 md12 text-left><h4>Lisää kysely</h4></v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  label="Otsikko"
                  prepend-icon="mdi-account"
                  :rules="[rules.required]"
                  v-model="addFeedbackValues.feedbackTitle"
                  autocomplete="off"
                />
              </v-flex>
              <v-flex xs12 md12>
                <v-textarea
                  label="Palaute/Kysymys"
                  prepend-icon="mdi-information-variant"
                  v-model="addFeedbackValues.feedbackMessage"
                  autocomplete="off"
                />
              </v-flex>

              <v-flex xs12 text-xs-right>
                <v-btn
                  class="mx-0 font-weight-light"
                  color="general"
                  @click.prevent="addNewFeedback"
                >
                  Lähetä palaute
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import FeedbackService from '@/services/PowerGuard/FeedbackService.js';

export default {
  data() {
    return {
      feedbackState: [
        { name: 'Uusi', value: 'Uusi' },
        { name: 'Suljettu', value: 'Suljettu' },
      ],
      addFeedbackValues: {},
      message: null,
      error: null,
      rules: {
        required: (value) => !!value || 'Pakollinen tieto',
      },
    };
  },

  methods: {
    async addNewFeedback() {
      try {
        console.log(this.addFeedbackValues);
        const response = await FeedbackService.addNewFeedback(
          this.addFeedbackValues
        );
        this.addFeedbackValues = {};
        this.message = response.data.message;
        this.error = response.error;
        setTimeout(() => {
          this.error = null;
          this.message = null;
          this.$router.push({
            name: 'powerguard',
          });
        }, 3000);
      } catch (error) {
        this.error = error.response.data.error;
        setTimeout(() => {
          this.error = null;
        }, 3000);
      }
    },
  },
};
</script>
